/* eslint-disable */

import { useRecoilValueLoadable } from 'recoil'
import { InProgressOrders } from '../../store/HomePageStore'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

const InProgressOrdersComponent = () => {
  const navigate = useNavigate()
  const inProgressOrders = useRecoilValueLoadable(InProgressOrders)
  const [validInProgressBasketOrders, setValidInProgressBasketOrders] = useState({})

  useEffect(() => {
    if (inProgressOrders.state === 'hasValue' && inProgressOrders?.contents?.data?.length > 0) {
      setValidInProgressBasketOrders(
        groupByBasketIdValidInProgress(inProgressOrders?.contents?.data),
      )
    }
  }, [inProgressOrders])

  const groupByBasketIdValidInProgress = (orders) =>
    orders?.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
      if (!customerBasketInvestmentId) return acc

      if (!acc[customerBasketInvestmentId]) {
        acc[customerBasketInvestmentId] = []
      }
      acc[customerBasketInvestmentId].push({ basketStatus, ...order })

      return acc
    }, {})

  // // Sample data for testing
  // const orders = {
  //   code: 200,
  //   data: [
  //     {
  //       settlementType: 'T2',
  //       schemeCode: 21520,
  //       schemeName: 'Parag Parikh Flexi Cap Fund-Reg(G)',
  //       customerBasketInvestmentId: 1723,
  //       amount: 0.0,
  //       customerBasketName: "Nandish's Retirement Plan",
  //       amcCode: 400049,
  //       legalName: null,
  //       bseSchemeCode: 'PP001RG-GR',
  //       createdTimestamp: '2025-10-18 07:57:58.682',
  //     },
  //     {
  //       settlementType: 'T2',
  //       schemeCode: 21520,
  //       schemeName: 'Parag Parikh Flexi Cap Fund-Reg(G)',
  //       customerBasketInvestmentId: 1723,
  //       amount: 0.0,
  //       customerBasketName: "Nandish's Retirement Plan",
  //       amcCode: 400049,
  //       legalName: null,
  //       bseSchemeCode: 'PP001RG-GR',
  //       createdTimestamp: '2025-10-18 07:58:17.934',
  //     },
  //     {
  //       settlementType: 'T2',
  //       schemeCode: 21520,
  //       schemeName: 'Parag Parikh Flexi Cap Fund-Reg(G)',
  //       customerBasketInvestmentId: 1723,
  //       amount: 0.0,
  //       customerBasketName: "Nandish's Retirement Plan",
  //       amcCode: 400049,
  //       legalName: null,
  //       bseSchemeCode: 'PP001RG-GR',
  //       createdTimestamp: '2025-10-18 09:36:39.072',
  //     },

  //     {
  //       settlementType: 'T2',
  //       schemeCode: 21520,
  //       schemeName: 'Parag Parikh Flexi Cap Fund-Reg(G)',
  //       customerBasketInvestmentId: 1723,
  //       amount: 0.0,
  //       customerBasketName: "Nandish's Retirement Plan",
  //       amcCode: 400049,
  //       legalName: null,
  //       bseSchemeCode: 'PP001RG-GR',
  //       createdTimestamp: '2025-10-18 09:36:39.072',
  //     },

  //     {
  //       settlementType: 'T2',
  //       schemeCode: 21520,
  //       schemeName: 'Parag Parikh Flexi Cap Fund-Reg(G)',
  //       customerBasketInvestmentId: 1724,
  //       amount: 0.0,
  //       customerBasketName: "Nandish's Retirement Plan",
  //       amcCode: 400049,
  //       legalName: null,
  //       bseSchemeCode: 'PP001RG-GR',
  //       createdTimestamp: '2025-10-18 09:36:39.072',
  //     },

  //     {
  //       settlementType: 'T2',
  //       schemeCode: 21520,
  //       schemeName: 'Parag Parikh Flexi Cap Fund-Reg(G)',
  //       customerBasketInvestmentId: 1724,
  //       amount: 0.0,
  //       customerBasketName: "Nandish's Retirement Plan",
  //       amcCode: 400049,
  //       legalName: null,
  //       bseSchemeCode: 'PP001RG-GR',
  //       createdTimestamp: '2025-10-18 09:36:39.072',
  //     },

  //     {
  //       settlementType: 'T2',
  //       schemeCode: 21520,
  //       schemeName: 'Parag Parikh Flexi Cap Fund-Reg(G)',
  //       customerBasketInvestmentId: 1725,
  //       amount: 0.0,
  //       customerBasketName: "Nandish's Retirement Plan",
  //       amcCode: 400049,
  //       legalName: null,
  //       bseSchemeCode: 'PP001RG-GR',
  //       createdTimestamp: '2025-10-18 09:36:39.072',
  //     },
  //   ],
  //   message: 'All customer in-progress orders fetched successfully.',
  //   status: 'SUCCESS',
  // }

  // // Count unique baskets
  // const uniqueBaskets = new Set(orders?.data?.map((order) => order.customerBasketInvestmentId))
  // const basketCount = uniqueBaskets.size

  // Animation variants
  const bannerVariants = {
    hidden: {
      opacity: 0,
      y: -20,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
        staggerChildren: 0.1,
      },
    },
    exit: {
      opacity: 0,
      y: -20,
      scale: 0.95,
      transition: { duration: 0.3 },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.4, ease: 'easeOut' },
    },
  }

  const countVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: 'backOut',
        delay: 0.2,
      },
    },
  }

  const buttonVariants = {
    rest: { scale: 1, opacity: 1 },
    hover: {
      scale: 1.05,
      opacity: 0.9,
      transition: { duration: 0.2 },
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.1 },
    },
  }

  // Don't show banner if no orders
  if (
    inProgressOrders?.state === 'hasValue' &&
    (inProgressOrders?.contents?.message === 'No in-progress orders found' ||
      inProgressOrders?.contents?.data?.length === 0 ||
      Object.keys(validInProgressBasketOrders).length === 0)
  ) {
    return null
  }

  return (
    <motion.div
      className='fabits-card mx-4 mt-4 lg:mt-0 lg:mx-0 p-4'
      variants={bannerVariants}
      initial='hidden'
      animate='visible'
      exit='exit'
      layout
    >
      <div className='flex items-center justify-between'>
        <motion.div className='flex items-center gap-3' variants={itemVariants}>
          <motion.div
            className='h-8 w-8 bg-secondary-300 rounded-full flex items-center justify-center'
            variants={countVariants}
            whileHover={{
              scale: 1.1,
              rotate: 5,
              transition: { duration: 0.2 },
            }}
          >
            <motion.svg
              className='h-4 w-4 text-black-950'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              animate={{ rotate: [0, 360] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'linear',
                delay: 1,
              }}
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
              />
            </motion.svg>
          </motion.div>
          <motion.div variants={itemVariants}>
            <motion.p
              className='text-sm font-semibold text-black-950'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.4 }}
            >
              Orders in progress
            </motion.p>
            <motion.p
              className='text-xs text-black-500'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4, duration: 0.4 }}
            >
              Your investments are being processed
            </motion.p>
          </motion.div>
        </motion.div>
        <motion.div
          className='text-right'
          onClick={() =>
            navigate('/dashboard/mutual-funds/orders', { state: { tab: 'in-progress' } })
          }
          variants={buttonVariants}
          initial='rest'
          whileHover='hover'
          whileTap='tap'
        >
          <motion.p
            className='text-xs lg:text-lg font-semibold text-primary-600 cursor-pointer'
            whileHover={{
              color: '#3120e2',
              transition: { duration: 0.2 },
            }}
          >
            View Orders
          </motion.p>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default InProgressOrdersComponent
